export default {
    form: {},
    useOcr: false,
    restrictDuplicateCustomers: true,
    isIndustrial: true,
    isTaxIdRequired: false,
    isTaxIdMandatory: false,
    taxIdNote: null,
    idDocumentExpiryNote: null,
}
